import { render, staticRenderFns } from "./DsnButtonOrder.vue?vue&type=template&id=17180de8&"
import script from "./DsnButtonOrder.vue?vue&type=script&lang=js&"
export * from "./DsnButtonOrder.vue?vue&type=script&lang=js&"
import style0 from "./DsnButtonOrder.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports